import React from 'react';
import { GridItem } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import { DDL } from 'types/general.types';
import { FormSubtitle, InputField } from 'app/components/Core';
import { toCountryOptions } from 'app/components/Profile/ProfilePersonalSection/utils';

import { ChakraAutocompleteField } from 'app/components/Core/ChakraAutocompleteField/ChakraAutocompleteField';
import { ContributionFormData } from '../types';

interface LocationFieldsProps {
  countries: DDL;
}

export const LocationFields: React.FC<LocationFieldsProps> = ({
  countries,
}) => {
  const {
    formState: { errors },
    register,
    control,
  } = useFormContext<ContributionFormData>();

  return (
    <>
      <GridItem w="full" gridColumn="1 / 4">
        <FormSubtitle
          containerStyleProps={{ width: 'full', pt: 4 }}
          tooltip="Studio or venue location of the contribution"
        >
          Location
        </FormSubtitle>
      </GridItem>
      <GridItem>
        <InputField
          label="Location Name"
          isInvalid={Boolean(errors?.location?.name)}
          errorMessage={errors?.location?.name?.message}
          data-testid="location-name"
          width="100%"
          {...register('location.name')}
        />
      </GridItem>
      <GridItem>
        <ChakraAutocompleteField
          control={control}
          label="Country"
          name="location.country"
          options={toCountryOptions(countries)}
          isInvalid={Boolean(errors?.location?.country)}
          errorMessage={errors?.location?.country?.message}
          isClearable
          dataTestId="country"
        />
      </GridItem>
      <GridItem>
        <InputField
          label="Address"
          isInvalid={Boolean(errors?.location?.address)}
          errorMessage={errors?.location?.address?.message}
          data-testid="location-address"
          width="100%"
          {...register('location.address')}
        />
      </GridItem>
      <GridItem />
      <GridItem />
    </>
  );
};
